document.addEventListener('DOMContentLoaded', function () {

  // ---- PARTE 1: Labels de Appstle ----
  function updateAppstleLabels() {
    document.querySelectorAll('.appstle_subscription_radio_wrapper').forEach(function (wrapper) {
      var badge = wrapper.querySelector('.appstle-save-badge');
      var discount = '10%';
      if (badge) {
        var match = badge.innerText.match(/\d+/);
        if (match) discount = match[0] + '%';
        badge.style.display = 'none';
      }

      var textEl = wrapper.querySelector('.appstle_subscribe_save_text');
      if (textEl && textEl.innerText.toLowerCase().includes('subscribe')) {
        textEl.innerText = 'Subscribe & Save Up to ' + discount;
      }

      var amountWrapper = wrapper.querySelector('.appstle_subscription_amount_wrapper');
      if (amountWrapper && !amountWrapper.querySelector('.custom-discount-label')) {
        var label = document.createElement('span');
        label.className = 'custom-discount-label';
        label.innerText = discount + ' off';
        label.style.cssText = 'font-size:12px; color:green; font-weight:bold; margin-left:6px;';
        amountWrapper.appendChild(label);
      }
    });
  }

  setTimeout(updateAppstleLabels, 500);
  setTimeout(updateAppstleLabels, 1500);
  setTimeout(updateAppstleLabels, 3000);

function updatePriceForQuantity(quantity) {
  // Actualizar el custom-discount-label según el tier
  var discountLabel = document.querySelector('.custom-discount-label');
  if (discountLabel) {
    if (quantity >= 3) {
      discountLabel.innerText = '20% off';
    } else if (quantity === 2) {
      discountLabel.innerText = '15% off';
    } else {
      discountLabel.innerText = '10% off';
    }
  }

  if (quantity <= 3) return;

  // Obtener precio base del variant activo
  var priceEl = document.querySelector('.price__regular .price-item');
  if (!priceEl) return;

  var basePrice = parseFloat(priceEl.innerText.replace('$', '').trim());
  if (isNaN(basePrice)) return;

  // 20% de descuento para 3+
  var discountedUnit = basePrice * 0.80;
  var total = discountedUnit * quantity;

  // Actualizar precio mostrado
  var finalPriceEl = document.querySelector('.appstle_subscription_final_price');
  if (finalPriceEl) {
    finalPriceEl.innerText = '$' + total.toFixed(2);
  }
}

  // ---- PARTE 2: Sync bundle con quantity via MutationObserver ----
  function selectBundleTier(quantity) {
    if (quantity === 1) {
      var alreadySelected = document.querySelector('.ab-volume-discount-item-1.ab-volume-discount-item-selected');
      if (!alreadySelected) document.querySelector('.ab-volume-discount-item-content-1').click();
    } else if (quantity === 2) {
      var alreadySelected = document.querySelector('.ab-volume-discount-item-2.ab-volume-discount-item-selected');
      if (!alreadySelected) document.querySelector('.ab-volume-discount-item-content-2').click();
    } else if (quantity === 3) {
      var alreadySelected = document.querySelector('.ab-volume-discount-item-3.ab-volume-discount-item-selected');
      if (!alreadySelected) document.querySelector('.ab-volume-discount-item-content-3').click();
    } else if (quantity === 4) {
      var alreadySelected = document.querySelector('.ab-volume-discount-item-4.ab-volume-discount-item-selected');
      if (!alreadySelected) document.querySelector('.ab-volume-discount-item-content-4').click();
    } else if (quantity >= 5) {
      var alreadySelected = document.querySelector('.ab-volume-discount-item-5.ab-volume-discount-item-selected');
      if (!alreadySelected) document.querySelector('.ab-volume-discount-item-content-5').click();
    }
    updatePriceForQuantity(quantity);
  }

  function watchQuantity() {
    var quantityInput = document.getElementById('quantity');
    if (!quantityInput) return;

    var lastValue = quantityInput.value;

    var observer = new MutationObserver(function () {
      var newValue = quantityInput.value;
      if (newValue !== lastValue) {
        lastValue = newValue;
        var qty = parseInt(newValue, 10);
        if (!isNaN(qty)) selectBundleTier(qty);
      }
    });

    observer.observe(quantityInput, { attributes: true, attributeFilter: ['value'] });

    // También escuchar eventos directos
    quantityInput.addEventListener('change', function () {
      var qty = parseInt(this.value, 10);
      if (!isNaN(qty)) selectBundleTier(qty);
    });

    quantityInput.addEventListener('input', function () {
      var qty = parseInt(this.value, 10);
      if (!isNaN(qty)) selectBundleTier(qty);
    });
  }

  setTimeout(watchQuantity, 1000);

});